export enum ReplaceEmailAddressOptionEnum {
  None,
  MainContact,
  BillingContact,
  EmailType,
  EventRegistration,
  EventAttendee,
  InvoiceContact,
}
